export default __webpack_public_path__ + "static/media/create-treatment.c18e50b7.webp";